import React from 'react'
import { Card, Row, Col, Statistic } from 'antd'
import { SyncOutlined } from '@ant-design/icons'
import { EmailSystemStatus } from '../interfaces/interfaces'
import { getStatusColor } from '../utils/helpers'

interface SystemInfoProps {
  status: EmailSystemStatus | null
}

export const SystemInfo: React.FC<SystemInfoProps> = ({ status }) => {
  const utilizationPercent = status
    ? Math.round((status.activeEmailSends / status.maxConcurrent) * 100)
    : 0

  return (
    <Card title="Системная информация" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <Statistic
            title="Активных отправок"
            value={status?.activeEmailSends || 0}
            suffix={`/ ${status?.maxConcurrent || 5}`}
            valueStyle={{ color: getStatusColor(utilizationPercent) }}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Загрузка системы"
            value={utilizationPercent}
            suffix="%"
            valueStyle={{ color: getStatusColor(utilizationPercent) }}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Активных запросов"
            value={status?.activeRequests.length || 0}
            prefix={<SyncOutlined spin={!!status?.activeRequests.length} />}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="Статус"
            value={utilizationPercent < 100 ? 'Норма' : 'Перегрузка'}
            valueStyle={{ color: getStatusColor(utilizationPercent), fontSize: 20 }}
          />
        </Col>
      </Row>
    </Card>
  )
}

